import 'marketing.sass'
import Rails from '@rails/ujs'

import 'utils/drawer'
import 'utils/headerNav'
import 'utils/beacons'
import 'utils/appHeight'
import 'utils/tooltip'
import 'utils/rwLinkModifier'
import 'stimulus'
import 'marketing/book-a-demo'
import 'marketing/ebook'

import { initSentry } from 'utils/sentry'
import { onDomReady } from 'utils/onDomReady'
import { initIntervalToggle } from 'utils/intervalToggle'
import { getUserInfo } from 'api'

Rails.start()

onDomReady(() => {
  if (document.querySelector('[data-simplebar]')) {
    import('utils/simpleBar')
  }

  if (document.querySelector('.data-filter-section__content')) {
    import('utils/filterData')
  }

  if (document.querySelector('.metric-dimension-section__content')) {
    import('utils/metricDimensionFilter')
  }

  if (document.querySelector('.js-lottie-anim')) {
    import('utils/lottieAnimation')
  }

  if (document.querySelector('.faq-item')) {
    import('utils/faq')
  }

  if (document.querySelector('.horizontal-carousel')) {
    import('utils/horizontalCarousel')
  }

  if (document.querySelector('.multiselect')) {
    import('utils/multiselect')
  }

  if (document.querySelector('.destinations-filter__list')) {
    import('utils/destinationsFilter')
  }

  if (document.querySelector('.img-highlights')) {
    import('utils/imgHighlights')
  }

  if (document.querySelector('.mainFeatureVideo')) {
    import('utils/wistiaLazyLoading')
  }

  if (document.querySelector('.infinite-slider')) {
    import('utils/infiniteSlider')
  }

  if (document.querySelector('.roles-toggle__input')) {
    import('utils/rolesTabs')
  }

  if (document.querySelector('.roles-slider')) {
    import('utils/rolesCarousel')
  }

  if (document.querySelector('.content-tabs-toggle__input')) {
    import('utils/contentTabs')
  }

  if (document.querySelector('.horizontal-accordion-item__button')) {
    import('utils/horizontalAccordion')
  }

  if (document.querySelector('.similar-sources-carousel')) {
    import('utils/similarSourcesCarousel')
  }

  if (document.querySelector('.grid-component__slider')) {
    import('utils/gridComponentCarousel')
  }

  if (document.querySelector('.data-filter-section--dashboards')) {
    import('utils/dashboardsFilter')
  }

  if (document.querySelector('.data-filter-section--data-set-templates')) {
    import('utils/dataSetTemplatesFilter')
  }

  if (document.querySelector('.agent-skills--filterable')) {
    import('utils/agentSkillsFilter')
  }

  if (document.querySelector('.skill-instructions')) {
    import('utils/skillInstructions')
  }

  if (document.querySelector('.plan-card')) {
    import('marketing/plans')
  }

  if (document.querySelector('.image-cards__content')) {
    import('marketing/image-cards')
  }

  Array.from(document.querySelectorAll('.interval-toggle-container')).forEach(
    container => initIntervalToggle(container)
  )

  const triggerInitSentry = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(initSentry, { timeout: 2000 })
    } else {
      setTimeout(initSentry, 500)
    }
  }

  triggerInitSentry()

  getUserInfo().then(response => {
    if (!response) {
      return
    }

    const { data } = response
    if (!data) {
      return
    }

    if (data.email) {
      const typeformLink = document.querySelector('.dashboards-typeform-link')
      if (typeformLink) {
        typeformLink.href = `https://railsware2.typeform.com/to/ZqwOYff6#email=${encodeURIComponent(
          data.email
        )}`
      }
    }

    const runTrackers = () => {
      // gtm
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ userId: data.id })
      // hj
      if (window.hj) {
        window.hj('identify', null, {
          user_id: data.id,
          account_id: data.selected_account_id
        })
      }
      // helpscout
      if (window.Beacon) {
        window.Beacon('identify', {
          email: data.email
        })

        window.Beacon('prefill', {
          email: data.email
        })
      }
      // clarity
      if (window.clarity) {
        window.clarity('set', 'user_id', data.id)
        window.clarity('set', 'account_id', data.selected_account_id)
      }
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(runTrackers, { timeout: 2000 })
    } else {
      setTimeout(runTrackers, 500)
    }
  })
})
